import React from "react";
import Masonry from "react-masonry-css";
import { FaExternalLinkAlt } from "react-icons/fa";

import teamData from "../data/teamData.json";

const breakpointColumnsObj = {
  default: 3,
  1100: 2,
  700: 1,
};

const Team = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-4xl font-bold text-center mb-10">Meet the Team</h2>
      <p className="text-center text-gray-500 mb-10 max-w-2xl mx-auto">
        A passionate collective building Web3, AI, mobile, and enterprise-grade
        software solutions.
      </p>

      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="flex gap-6"
        columnClassName="bg-clip-padding"
      >
        {teamData.members.map((member, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow p-6 flex flex-col space-y-4 border border-gray-100"
          >
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                {member.name}
              </h3>
              <p className="text-sm text-gray-600">
                {member.education || "Team Member"}
              </p>
            </div>

            {member.skills && (
              <div>
                <h4 className="font-medium text-gray-700 mb-1">Skills:</h4>
                <div className="flex flex-wrap gap-2">
                  {member.skills.map((skill, i) => (
                    <span
                      key={i}
                      className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {member.projects?.length > 0 && (
              <div>
                <h4 className="font-medium text-gray-700 mb-1">Projects:</h4>
                <ul className="list-disc ml-5 space-y-1 text-sm text-gray-600">
                  {member.projects.map((project, i) => (
                    <li key={i}>{project.description || project.name}</li>
                  ))}
                </ul>
              </div>
            )}

            {member.portfolio?.length > 0 && (
              <div>
                <h4 className="font-medium text-gray-700 mb-1">Portfolio:</h4>
                <ul className="text-blue-600 text-sm space-y-1">
                  {member.portfolio.map((link, i) => (
                    <li key={i}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline inline-flex items-center gap-1"
                      >
                        {link.type || "Portfolio"}{" "}
                        <FaExternalLinkAlt className="w-3 h-3" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </Masonry>
    </div>
  );
};

export default Team;
